import { Skeleton, Typography } from "antd";
import { useGetLectureByIdQuery } from "../../../../app/features/adminContent/adminContent.api";

const { Title } = Typography;

type Props = {
  lectureId: number;
};

export default function LectureViewer({ lectureId }: Props) {
  const { data: lecture, isLoading } = useGetLectureByIdQuery(lectureId);

  if (isLoading) {
    return <Skeleton active />;
  }

  if (!lecture) {
    return <div>Lecture not found</div>;
  }

  const renderContent = () => {
    const type = lecture.contentType?.toUpperCase();

    const getYouTubeEmbedUrl = (url: string) => {
      try {
        let videoId = "";
        if (url.includes("youtube.com/watch")) {
          const urlParams = new URLSearchParams(new URL(url).search);
          videoId = urlParams.get("v") || "";
        } else if (url.includes("youtu.be/")) {
          videoId = url.split("youtu.be/")[1]?.split("?")[0] || "";
        } else if (url.includes("youtube.com/embed/")) {
          return url; // Already an embed URL
        }

        if (videoId) {
          return `https://www.youtube.com/embed/${videoId}`;
        }
        return url; // Return original if not recognized/convertible
      } catch (e) {
        return url;
      }
    };

    const embedUrl = getYouTubeEmbedUrl(lecture.content?.url?.trim());

    switch (type) {
      case "VIDEO":
        return (
          <div className="relative]rounded-lg overflow-hidden">
            <div
              className="relative w-full"
              style={{ paddingBottom: "56.25%" }}
            >
              <iframe
                src={embedUrl}
                title={lecture.title}
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        );
      case "PDF":
      case "EMBED":
        return (
          <div className="w-full aspect-video border rounded-lg overflow-hidden relative">
            <div className="absolute top-2 right-3 size-11 z-10 !bg-[#313131]" />
            <iframe
              src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                `${lecture.content?.url || ""}`,
              )}&embedded=true`}
              className="w-full h-full"
              title="Document Viewer"
            />
          </div>
        );
      case "ARTICLE":
        return (
          <div
            className="prose max-w-none p-4 bg-gray-50 rounded-lg"
            dangerouslySetInnerHTML={{
              __html: lecture.articleHtml || lecture.content?.html || "",
            }}
          />
        );
      default:
        return <div>Unsupported content type: {lecture.contentType}</div>;
    }
  };

  return (
    <div className="space-y-4">
      <div className="border-b pb-2">
        <Title level={4} className="!mb-0">
          {lecture.title}
        </Title>
        {/* <Paragraph type="secondary" className="!mb-0">
          Type: {lecture.contentType}
        </Paragraph> */}
      </div>
      {renderContent()}
    </div>
  );
}
